function targetSystems(state = [], action = {}) {
    return state;
}

export default targetSystems;